import * as React from 'react';
import { useTranslationHook } from 'PyzShopUi/scripts/utils/translationHook';

export interface IImportantNote {
    id_important_note: string;
    text: string;
}

export interface IImportantNotesProps {
    notes?: IImportantNote[];
}

export const ImportantNotes: React.FunctionComponent<IImportantNotesProps> = props => {
    const { notes } = props;
    const { translate } = useTranslationHook();

    return (
        <>
            <div className="grid-x grid-margin-x grid-padding-x">
                <div className="cell">
                    <div className="m-info grid-x grid-padding-x">
                        <div className="cell i-box highlight">
                            <p className="paragraph-x">
                                <strong>{translate('Important notes', { ns: 'article-detail'})}</strong>
                            </p>
                            {
                                notes.map(note => {
                                    return <React.Fragment key={note.id_important_note}>
                                        <p className="paragraph-x">{note.text}</p>
                                    </React.Fragment>;
                                })
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
